/**
 * NRA collection PLP — grid/list toggle + Brand filter (product.vendor).
 */
(function () {
  var STORAGE_KEY = 'nra-plp-view';
  var BRAND_PARAM = 'brand';

  function getPreferredView() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'list' || saved === 'grid') return saved;
    } catch (e) {}
    return 'grid';
  }

  function setPreferredView(view) {
    try {
      localStorage.setItem(STORAGE_KEY, view);
    } catch (e) {}
  }

  function applyView(root, view) {
    if (!root) return;
    root.setAttribute('data-view', view);
    root.classList.toggle('nra-plp--list', view === 'list');
    root.classList.toggle('nra-plp--grid', view === 'grid');

    root.querySelectorAll('[data-plp-view]').forEach(function (btn) {
      var active = btn.getAttribute('data-plp-view') === view;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function getBrandFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get(BRAND_PARAM) || '';
    } catch (e) {
      return '';
    }
  }

  function setBrandInUrl(brand) {
    try {
      var url = new URL(window.location.href);
      if (brand) url.searchParams.set(BRAND_PARAM, brand);
      else url.searchParams.delete(BRAND_PARAM);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fetchCollectionProducts(handle) {
    var products = [];
    var page = 1;

    function next() {
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var batch = (data && data.products) || [];
          products = products.concat(batch);
          if (batch.length < 250) return products;
          page += 1;
          return next();
        });
    }

    return next();
  }

  function uniqueVendors(products) {
    var map = {};
    products.forEach(function (p) {
      var v = (p.vendor || '').trim();
      if (v) map[v] = true;
    });
    return Object.keys(map).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function renderBrandList(filterRoot, vendors, activeBrand) {
    var list = filterRoot.querySelector('[data-nra-brand-list]');
    var empty = filterRoot.querySelector('[data-nra-brand-empty]');
    if (!list) return;

    list.innerHTML = '';
    if (!vendors.length) {
      if (empty) empty.classList.remove('is-hidden');
      return;
    }
    if (empty) empty.classList.add('is-hidden');

    vendors.forEach(function (vendor) {
      var li = document.createElement('li');
      li.className = 'nra-brand-filter__item';
      li.setAttribute('data-brand-label', vendor.toLowerCase());

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nra-brand-filter__link' + (vendor === activeBrand ? ' is-active' : '');
      btn.setAttribute('data-nra-brand-value', vendor);
      btn.innerHTML =
        '<span class="nra-brand-filter__check" aria-hidden="true"></span>' +
        '<span class="nra-brand-filter__label">' + escapeHtml(vendor) + '</span>';

      li.appendChild(btn);
      list.appendChild(li);
    });
  }

  function updateBrandChrome(filterRoot, activeBrand, matchCount) {
    var activeEl = filterRoot.querySelector('[data-nra-brand-active]');
    var clearBtn = filterRoot.querySelector('[data-nra-brand-clear]');
    if (activeEl) {
      if (activeBrand) {
        activeEl.textContent = '(1)';
        activeEl.classList.remove('is-hidden');
      } else {
        activeEl.textContent = '';
        activeEl.classList.add('is-hidden');
      }
    }
    if (clearBtn) clearBtn.classList.toggle('is-hidden', !activeBrand);

    var countEl = document.getElementById('ProductCount');
    if (countEl && typeof matchCount === 'number') {
      if (activeBrand) {
        countEl.innerHTML =
          'Showing <strong>' + matchCount + '</strong> products' +
          ' <span class="nra-plp__count-note">for ' + escapeHtml(activeBrand) + '</span>';
      }
    }
  }

  function cardHtml(product) {
    var image = (product.images && product.images[0]) || null;
    var variant = (product.variants && product.variants[0]) || {};
    var price = typeof variant.price === 'string' ? parseFloat(variant.price) * 100 : Number(variant.price || 0);
    // products.json returns price as string dollars, e.g. "25.00"
    if (typeof variant.price === 'string' && variant.price.indexOf('.') !== -1) {
      price = Math.round(parseFloat(variant.price) * 100);
    }
    var available = product.variants.some(function (v) { return v.available; });
    var url = '/products/' + product.handle;
    var sku = variant.sku || '';

    return (
      '<li class="nra-plp__cell">' +
        '<article class="nra-plp-item" data-vendor="' + escapeHtml(product.vendor || '') + '">' +
          '<a class="nra-plp-item__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
            (image
              ? '<img class="nra-plp-item__img" src="' + escapeHtml(image.src) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="600" height="600">'
              : '<span class="nra-plp-item__ph" aria-hidden="true"></span>') +
          '</a>' +
          '<div class="nra-plp-item__body">' +
            (product.vendor ? '<p class="nra-plp-item__vendor">' + escapeHtml(product.vendor) + '</p>' : '') +
            '<h3 class="nra-plp-item__title"><a href="' + url + '">' + escapeHtml(product.title) + '</a></h3>' +
            '<div class="nra-plp-item__meta">' +
              (sku ? '<span class="nra-plp-item__sku">Item # ' + escapeHtml(sku) + '</span>' : '') +
              (product.product_type ? '<span class="nra-plp-item__type">' + escapeHtml(product.product_type) + '</span>' : '') +
            '</div>' +
          '</div>' +
          '<div class="nra-plp-item__aside">' +
            '<p class="nra-plp-item__price">' + money(price) + '</p>' +
            '<p class="nra-plp-item__stock ' + (available ? 'is-in' : 'is-out') + '">' +
              (available ? 'In stock' : 'Out of stock') +
            '</p>' +
            '<a class="nra-plp-item__cta" href="' + url + '">View details</a>' +
          '</div>' +
        '</article>' +
      '</li>'
    );
  }

  function applyBrandFilter(plpRoot, filterRoot, products, brand) {
    var grid = document.getElementById('product-grid');
    var container = document.getElementById('ProductGridContainer');
    if (!grid || !container) return;

    var matched = brand
      ? products.filter(function (p) { return (p.vendor || '').trim() === brand; })
      : products;

    // Prefer hiding existing Liquid cards when no brand (restore) or when all matches are on the page.
    if (!brand) {
      // Reload to restore Liquid-rendered pagination/facets state cleanly
      var url = new URL(window.location.href);
      url.searchParams.delete(BRAND_PARAM);
      window.location.href = url.toString();
      return;
    }

    if (!matched.length) {
      container.innerHTML =
        '<div class="nra-plp__empty collection" id="product-grid">' +
          '<h2 style="color:#0a1626;">No products found</h2>' +
          '<p>Try clearing filters or <a href="' + (filterRoot.getAttribute('data-collection-handle') ? '/collections/' + filterRoot.getAttribute('data-collection-handle') : '#') + '">view the full collection</a>.</p>' +
        '</div>';
    } else {
      var pagination = container.querySelector('.nra-plp__pagination');
      if (pagination) pagination.remove();
      var wrap = container.querySelector('.collection') || container;
      if (!container.querySelector('.collection')) {
        container.innerHTML = '<div class="collection"><ul id="product-grid" class="nra-plp__list"></ul></div>';
        grid = document.getElementById('product-grid');
      } else {
        grid = document.getElementById('product-grid') || grid;
      }
      grid.innerHTML = matched.map(cardHtml).join('');
    }

    setBrandInUrl(brand);
    updateBrandChrome(filterRoot, brand, matched.length);
    renderBrandList(filterRoot, uniqueVendors(products), brand);
    applyView(plpRoot, getPreferredView());
  }

  function initBrandFilter(plpRoot) {
    var filterRoot = document.querySelector('[data-nra-brand-filter]');
    if (!filterRoot || filterRoot.dataset.ready === '1') return;
    filterRoot.dataset.ready = '1';

    var handle = filterRoot.getAttribute('data-collection-handle');
    if (!handle) return;

    var search = filterRoot.querySelector('[data-nra-brand-search]');
    var clearBtn = filterRoot.querySelector('[data-nra-brand-clear]');
    var productsCache = null;
    var activeBrand = getBrandFromUrl();

    function ensureProducts() {
      if (productsCache) return Promise.resolve(productsCache);
      return fetchCollectionProducts(handle).then(function (products) {
        productsCache = products;
        return products;
      });
    }

    ensureProducts().then(function (products) {
      var vendors = uniqueVendors(products);
      renderBrandList(filterRoot, vendors, activeBrand);
      if (activeBrand) applyBrandFilter(plpRoot, filterRoot, products, activeBrand);
      else updateBrandChrome(filterRoot, '', vendors.length);
    }).catch(function () {
      var empty = filterRoot.querySelector('[data-nra-brand-empty]');
      if (empty) {
        empty.textContent = 'Unable to load brands.';
        empty.classList.remove('is-hidden');
      }
    });

    if (search && search.dataset.bound !== '1') {
      search.dataset.bound = '1';
      search.addEventListener('input', function () {
        var q = (search.value || '').trim().toLowerCase();
        filterRoot.querySelectorAll('[data-brand-label]').forEach(function (item) {
          var label = item.getAttribute('data-brand-label') || '';
          item.classList.toggle('is-hidden', q !== '' && label.indexOf(q) === -1);
        });
      });
    }

    if (filterRoot.dataset.clickBound !== '1') {
      filterRoot.dataset.clickBound = '1';
      filterRoot.addEventListener('click', function (event) {
        var brandBtn = event.target.closest('[data-nra-brand-value]');
        if (brandBtn && filterRoot.contains(brandBtn)) {
          event.preventDefault();
          var brand = brandBtn.getAttribute('data-nra-brand-value') || '';
          ensureProducts().then(function (products) {
            applyBrandFilter(plpRoot, filterRoot, products, brand);
          });
          return;
        }
        if (event.target.closest('[data-nra-brand-clear]')) {
          event.preventDefault();
          ensureProducts().then(function (products) {
            applyBrandFilter(plpRoot, filterRoot, products, '');
          });
        }
      });
    }
  }

  function bindRoot(root) {
    if (!root || root.dataset.plpBound === '1') return;
    root.dataset.plpBound = '1';

    var view = getPreferredView();
    applyView(root, view);
    initBrandFilter(root);

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-plp-view]');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      var next = btn.getAttribute('data-plp-view');
      if (next !== 'list' && next !== 'grid') return;
      setPreferredView(next);
      applyView(root, next);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-nra-plp]').forEach(bindRoot);
    // Facet AJAX may replace product grid; keep brand filter bound on aside
    var plp = document.querySelector('[data-nra-plp]');
    if (plp) initBrandFilter(plp);
  }

  function observeFacetRefresh() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var observer = new MutationObserver(function () {
      document.querySelectorAll('[data-nra-plp]').forEach(function (root) {
        root.dataset.plpBound = '';
        bindRoot(root);
        applyView(root, getPreferredView());
      });
    });
    observer.observe(container, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      observeFacetRefresh();
    });
  } else {
    initAll();
    observeFacetRefresh();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
